import React from 'react';
import { SliderButton } from '@typeform/embed-react';

import styles from './type_slide.module.css';

const TypeSlide = ({ children }) => {
  return (
    <SliderButton
      //onSubmit={() => console.log('')}
      className={styles.slide}
      id='ekcl7VZY'
      autoClose={600}
    >
      {children}
    </SliderButton>
  );
};

export default TypeSlide;
